
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Resultados from "../pages/resultados/page";
import Trajetoria from "../pages/trajetoria/page";
import ComoFunciona from "../pages/como-funciona/page";
import Contato from "../pages/contato/page";
import PoliticaPrivacidade from "../pages/politica-privacidade/page";
import TermosUso from "../pages/termos-uso/page";
import SitesAgente from "../pages/sites-agente/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sites-agente",
    element: <SitesAgente />,
  },
  {
    path: "/resultados",
    element: <Resultados />,
  },
  {
    path: "/trajetoria",
    element: <Trajetoria />,
  },
  {
    path: "/como-funciona",
    element: <ComoFunciona />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/politica-privacidade",
    element: <PoliticaPrivacidade />,
  },
  {
    path: "/termos-uso",
    element: <TermosUso />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
